
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medias",
      function () {
        return require("private-next-pages/medias.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medias"])
      });
    }
  